import React from 'react';
import { Modal, Button } from 'react-bootstrap'
import { Form, TextBox } from 'fw/forms'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Context from 'fw/system/Context'
import * as Notifications from 'fw/globals/Notifications'

class ReLogin extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
			processing: false,
			tries: 0,
			form: {
				passsword: ""
			}
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	onOpen = () => {
		this.setState({ tries: 0 });
	}

	onChange = (form) => {
		this.setState({ form: form });
	}

	ok = () => {
		this.setState({ processing: true });

		const rq = {
			login: Context.get("login"),
			password: this.state.form.password,
			reLogin: true
		}

		// Authenticate
		API.Security.post('/authentication/completeLogin', rq, {
			success: (sr) => {
				this.setState({
					processing: false,
					form: {
						passsword: ""
					}
				});

				// Relogin and close
				App.login(sr.data);
				this.props.onClose();
			},
			error: (sr) => {
					if (sr.data) {
					this.setState({
						processing: false
					});

					return;
				}

				// Regular authentication
				this.setState({
					processing: false,
					tries: this.state.tries + 1 
				}, function(){
					if (this.state.tries >= 3)
						this.cancel();
					else
						Notifications.error(sr.error.errorMessage);
				});
			}
		});
	}

	cancel = () => {
		this.props.onClose();
		App.logout();
		window.location.href = '/public/login';
	}

	render() {
		if (this.state.processing)
			return (
				<React.Fragment>
					<Modal show={this.state.visible} onEnter={this.onOpen}>
						<Modal.Header>
							<Modal.Title>Password Required</Modal.Title>
						</Modal.Header>
						<Modal.Body className="text-center">
							<h3>Signing in, please wait...</h3>
							<img src="/images/loading.gif" alt="Please wait..." />
							<br /><br />
						</Modal.Body>
						<Modal.Footer>
							<Button bsStyle="link" onClick={this.cancel}>Cancel</Button>
						</Modal.Footer>
					</Modal>
				</React.Fragment>)

		return (
			<React.Fragment>
				<Modal show={this.state.visible} onEnter={this.onOpen}>
					<Form
						onChange={this.onChange}
						values={this.state.form}
						onSubmit={this.ok}>
						<Modal.Header>
							<Modal.Title>Password Required</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Please enter your password to continue
							<TextBox name="password" type="password" placeholder="Password..." value="" required autoFocus />
							<br />
						</Modal.Body>
						<Modal.Footer>
							<Button bsStyle="link" onClick={this.cancel}>Cancel</Button>
							<Button bsStyle="success" type="submit">OK</Button>
						</Modal.Footer>
					</Form>
				</Modal>
			</React.Fragment>)
	}
}

export default ReLogin;



// WEBPACK FOOTER //
// ./src/areas/public/login/ReLogin.js